import { render } from "./ModifierComponent.vue?vue&type=template&id=cfa13938&scoped=true"
import script from "./ModifierComponent.vue?vue&type=script&lang=js"
export * from "./ModifierComponent.vue?vue&type=script&lang=js"

import "./ModifierComponent.vue?vue&type=style&index=0&id=cfa13938&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cfa13938"]])

export default __exports__